import { ArrowLeft, ShieldCheck } from "lucide-react";
import { ASSETS } from "@/data/magicalContent";
import { COMPANY } from "@/data/siteContact";

const LEGAL_CONTENT = {
  privacy: {
    title: "Privacy Policy",
    intro: "We respect families and handle personal information with care.",
    sections: [
      ["Information we collect", "Account name, email address, contact details, saved bag or wishlist choices, and enquiry messages needed to operate the website."],
      ["How we use information", "We use information to provide accounts, respond to enquiries, improve the experience, and prepare future orders or customer support."],
      ["Children’s privacy", "The website is designed for families. Accounts, purchases, and contact forms should be managed by a parent or guardian."],
      ["Data sharing", "We do not sell personal information. Service providers may process data only as needed for hosting, analytics, email, payments, or delivery."],
      ["Contact", `For privacy questions, contact ${COMPANY.legalName} at ${COMPANY.email} or ${COMPANY.phone}.`],
    ],
  },
  terms: {
    title: "Terms of Use",
    intro: "These starter terms govern use of the Niyati & Shivu website.",
    sections: [
      ["Using the website", "You may browse episodes, characters, products, and account features for personal, family, and non-commercial use."],
      ["Accounts", "Parents or guardians are responsible for account credentials and activity under their account."],
      ["Products and availability", "Product images, prices, sizes, availability, delivery estimates, and offers may change until an order is confirmed."],
      ["Intellectual property", "Niyati & Shivu characters, stories, artwork, videos, logos, and website content belong to their respective rights holders and may not be copied or reused without permission."],
      ["Contact", `Questions may be sent to ${COMPANY.email} or ${COMPANY.phone}.`],
    ],
  },
  shipping: {
    title: "Shipping Information",
    intro: "Starter shipping information for families in India and international customers.",
    sections: [
      ["Processing", "Orders are prepared after payment confirmation. Processing times will be shown at checkout once the store is activated."],
      ["Delivery", "Estimated delivery times depend on destination, courier availability, and product readiness."],
      ["Shipping charges", "Any delivery fee, free-shipping threshold, customs charge, or international charge will be displayed before payment."],
      ["Tracking", "Tracking details will be shared when available after dispatch."],
      ["Support", `For delivery help, contact ${COMPANY.email} or ${COMPANY.phone}.`],
    ],
  },
  returns: {
    title: "Returns & Refunds",
    intro: "Starter return information for parent trust and store readiness.",
    sections: [
      ["Return window", "Unused products in original condition may be eligible for return within 7 days of delivery, subject to final store policy."],
      ["Condition", "Products should be unworn, unwashed, unused, and returned with original tags and packaging."],
      ["Exceptions", "Personalized, hygiene-sensitive, final-sale, or damaged-after-delivery products may not be returnable."],
      ["Refunds", "Approved refunds are returned to the original payment method after inspection. Timelines depend on the payment provider."],
      ["Start a return", `Contact ${COMPANY.email} or ${COMPANY.phone} with your order details.`],
    ],
  },
};

export default function LegalPage({ page }) {
  const content = LEGAL_CONTENT[page];
  return (
    <main className="ns-content-page" data-testid={`${page}-page`}>
      <header className="ns-content-header"><a href="/" className="ns-season-brand" data-testid="legal-home-link"><img src={ASSETS.logo} alt="Niyati & Shivu logo" /><span><strong>Niyati &amp; Shivu</strong><small>Magical World</small></span></a><a href="/" className="ns-season-back" data-testid="legal-back-link"><ArrowLeft size={16} /> Back home</a></header>
      <section className="ns-legal-card">
        <p className="ns-kicker"><ShieldCheck size={14} /> Parent trust</p><h1>{content.title}</h1><p>{content.intro}</p>
        {content.sections.map(([title, text]) => <article key={title}><h2>{title}</h2><p>{text}</p></article>)}
        <small>Starter policy content for review by Madneel Ventures Pvt Ltd. Last updated: August 2026.</small>
      </section>
    </main>
  );
}
